import HundredBricksAPIError from '../../HundredBricksAPIError';
class RegisterRealOwnerError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('RegisterRealOwnerError', ...args);
    }
}
export default RegisterRealOwnerError;
